import React, { useRef } from 'react';
const Image = ({ data }) => {
  let image = useRef();

  return (
    <div
      ref={(el) => (image = el)}
      id={data.id}
      style={data.style || {}}
      className={data.classNames || ''}
    >
      <img src={data.url} alt={data.alt} />
    </div>
  );
};

export default Image;
